import React from "react";
import WordBitesSolver from "../components/wordbites/WordBitesSolver";

import Container from "react-bootstrap/Container";
import Menu from "../components/Menu";
import Footer from "../components/Footer";

function WordBites() {
  document.title = "Visual WordBites Solver"
  return (
    <div className="bg-light min-vh-100" style={{height: '100%'}}>
      <Menu colorScheme='light'/>

      <Container className="p-3 bg-white mt-3" style={{zIndex:3}}>
          <h1 className="text-center py-3">WordBites Solver!</h1>
        <WordBitesSolver />
      </Container>
      
      <Footer bg="dark"/>
    </div>
  );
}

export default WordBites;
